import React from 'react';
import '../css/page-loader.css';

const PageLoader = () => {
    return(
        <div className="page-loader" >
            <img src='/css/loader.svg' alt='Loader image' />
        </div>
    );
}

export default PageLoader;